window.CoolstarCategories = {
  "categories": {
    "poker-sets": {
      "title": "Poker sets",
      "zh": "扑克套装",
      "intro": "Build your set around the way you play. Browse by material, chip count or game type.",
      "image": "home-featured-set.jpg",
      "filters": [
        [
          "clay",
          "Clay poker sets",
          "黏土套装"
        ],
        [
          "ceramic",
          "Ceramic poker sets",
          "陶瓷套装"
        ],
        [
          "abs",
          "ABS poker sets",
          "ABS套装"
        ],
        [
          "pp",
          "PP poker sets",
          "PP套装"
        ],
        [
          "acrylic",
          "Acrylic poker sets",
          "亚克力套装"
        ],
        [
          "300",
          "300-chip sets",
          "300枚筹码套装"
        ],
        [
          "500",
          "500-chip sets",
          "500枚筹码套装"
        ],
        [
          "750",
          "750-chip sets",
          "750枚筹码套装"
        ],
        [
          "1000",
          "1,000-chip sets",
          "1,000枚筹码套装"
        ],
        [
          "tournament",
          "Tournament sets",
          "锦标赛套装"
        ],
        [
          "professional",
          "Professional sets",
          "专业套装"
        ],
        [
          "beginner",
          "Beginner sets",
          "初学者套装"
        ],
        [
          "venue",
          "Venue & Club Sets",
          "场馆与俱乐部套装"
        ],
        [
          "casual",
          "Casual sets",
          "休闲套装"
        ]
      ]
    },
    "poker-chips": {
      "title": "Poker chips",
      "zh": "扑克筹码",
      "intro": "Explore round chips and rectangular plaques. Compare materials, edge designs and original artwork.",
      "image": "material-clay-studio-v2.png",
      "filters": [
        [
          "clay",
          "Clay chips",
          "黏土筹码"
        ],
        [
          "ceramic",
          "Ceramic chips",
          "陶瓷筹码"
        ],
        [
          "abs",
          "ABS chips",
          "ABS筹码"
        ],
        [
          "pp",
          "PP chips",
          "PP筹码"
        ],
        [
          "acrylic",
          "Acrylic chips",
          "亚克力筹码"
        ],
        [
          "ceramic-plaque",
          "Ceramic plaques",
          "陶瓷方片筹码"
        ],
        [
          "acrylic-plaque",
          "Acrylic plaques",
          "亚克力方片筹码"
        ]
      ]
    },
    "tables-chairs": {
      "title": "Tables & chairs",
      "zh": "桌椅",
      "intro": "Find your table, choose a seat and complete the setup with mats and table accessories.",
      "image": "catalog-21.jpg",
      "filters": [
        [
          "texas",
          "Texas Hold’em tables",
          "德州扑克牌桌"
        ],
        [
          "blackjack",
          "Blackjack tables",
          "21点桌"
        ],
        [
          "roulette",
          "Roulette tables",
          "轮盘桌"
        ],
        [
          "craps",
          "Craps tables",
          "骰子桌"
        ],
        [
          "texas-mats",
          "Texas Hold’em mats",
          "德州桌垫"
        ],
        [
          "blackjack-mats",
          "Blackjack mats",
          "21点桌垫"
        ],
        [
          "chairs",
          "Poker chairs",
          "扑克椅"
        ],
        [
          "table-accessories",
          "Table accessories",
          "牌桌配件"
        ]
      ]
    },
    "poker-supplies": {
      "title": "Poker supplies",
      "zh": "扑克用品",
      "intro": "The essentials that keep play moving. Explore cards, markers, storage and table equipment.",
      "image": "catalog-83.jpg",
      "filters": [
        [
          "cards",
          "Playing cards",
          "扑克牌"
        ],
        [
          "dice",
          "Dice",
          "骰子"
        ],
        [
          "dealer",
          "Dealer buttons",
          "庄家按钮"
        ],
        [
          "all-in",
          "All-in buttons",
          "All-in牌"
        ],
        [
          "call",
          "Call buttons",
          "Call牌"
        ],
        [
          "blinds",
          "Blind markers",
          "盲位牌"
        ],
        [
          "cut-cards",
          "Cut cards",
          "切牌"
        ],
        [
          "guards",
          "Card protectors",
          "压牌码"
        ],
        [
          "cases",
          "Chip cases",
          "筹码箱"
        ],
        [
          "racks",
          "Chip racks",
          "码耙"
        ],
        [
          "trays",
          "Chip trays",
          "码盘"
        ],
        [
          "sleeves",
          "Card sleeves",
          "牌套"
        ],
        [
          "cash",
          "Cash boxes",
          "现金箱"
        ],
        [
          "equipment",
          "Table equipment",
          "桌面设备"
        ]
      ]
    }
  },
  "products": [
    {
      "category": "poker-sets",
      "title": "Silver clay chip set",
      "zh": "银色箱陶土筹码套装",
      "detail": "500 chips · aluminum case",
      "image": "catalog-00.jpg",
      "url": "https://www.coolstarpoker.com/products/coolstar-silver-500pcs-clay-poker-chip-set-aluminum-case-10-trays-50-each-1-1000-values-cards-dice-buttons-tournament-play",
      "tags": [
        "tournament",
        "professional",
        "clay",
        "500"
      ],
      "inquiry": false
    },
    {
      "category": "poker-sets",
      "title": "Ceramic starter set",
      "zh": "陶瓷入门筹码套装",
      "detail": "300 chips · aluminum case",
      "image": "catalog-01.jpg",
      "url": "https://www.coolstarpoker.com/products/300pc-professional-ceramic-poker-chip-set-black-metal-case",
      "tags": [
        "beginner",
        "casual",
        "ceramic",
        "300"
      ],
      "inquiry": false
    },
    {
      "category": "poker-sets",
      "title": "Professional ceramic set",
      "zh": "专业陶瓷筹码套装",
      "detail": "500 chips · metal case",
      "image": "catalog-60.jpg",
      "url": "https://www.coolstarpoker.com/products/500pc-professional-ceramic-poker-chip-set-black-metal-case",
      "tags": [
        "tournament",
        "professional",
        "ceramic",
        "500"
      ],
      "inquiry": false
    },
    {
      "category": "poker-sets",
      "title": "Gambler Palace chip bundle",
      "zh": "Gambler Palace筹码组合",
      "detail": "300 chips · case optional",
      "image": "catalog-96.png",
      "url": "https://www.coolstarpoker.com/products/poker-chips-gambler-palace-300",
      "tags": [
        "beginner",
        "casual",
        "300"
      ],
      "inquiry": false
    },
    {
      "category": "poker-sets",
      "title": "Monte Carlo set",
      "zh": "Monte Carlo筹码套装",
      "detail": "Patterned chips · carrying case",
      "image": "catalog-97.jpg",
      "url": "https://www.coolstarpoker.com/products/poker-set-monte-carlo",
      "tags": [
        "tournament",
        "professional",
        "casual"
      ],
      "inquiry": false
    },
    {
      "category": "poker-sets",
      "title": "Venue & Club project",
      "zh": "场馆与俱乐部采购方案",
      "detail": "Per-table quantities · trays · secure storage",
      "image": "home-featured-set.jpg",
      "url": "contact.html#quote-form",
      "tags": [
        "venue",
        "1000",
        "2000"
      ],
      "inquiry": true
    },
    {
      "category": "tables-chairs",
      "title": "Texas Hold’em table",
      "zh": "德州扑克牌桌",
      "detail": "LED table · 10-player layout",
      "image": "catalog-21.jpg",
      "url": "https://www.coolstarpoker.com/products/96-professional-led-poker-table-10-player-vip-security-top",
      "tags": [
        "texas"
      ],
      "inquiry": false
    },
    {
      "category": "tables-chairs",
      "title": "Blackjack table",
      "zh": "21点牌桌",
      "detail": "Folding table · 7-player layout",
      "image": "catalog-29.jpg",
      "url": "https://www.coolstarpoker.com/products/83-professional-folding-blackjack-table-7-player-casino-top",
      "tags": [
        "blackjack"
      ],
      "inquiry": false
    },
    {
      "category": "tables-chairs",
      "title": "Roulette table",
      "zh": "轮盘桌",
      "detail": "Wood frame · roulette layout",
      "image": "catalog-43.jpg",
      "url": "https://www.coolstarpoker.com/products/professional-95-deluxe-wood-roulette-table-pro-casino-felt",
      "tags": [
        "roulette"
      ],
      "inquiry": false
    },
    {
      "category": "tables-chairs",
      "title": "Craps table",
      "zh": "骰子桌",
      "detail": "Craps layout · padded rail",
      "image": "catalog-34.jpg",
      "url": "https://www.coolstarpoker.com/products/professional-136-deluxe-craps-table-blue-green-layouts",
      "tags": [
        "craps"
      ],
      "inquiry": false
    },
    {
      "category": "tables-chairs",
      "title": "Rectangular poker mat",
      "zh": "长方形扑克桌垫",
      "detail": "Rubber mat · multiple sizes",
      "image": "catalog-40.jpg",
      "url": "https://www.coolstarpoker.com/products/professional-rectangular-rubber-poker-mat-3-sizes-available",
      "tags": [
        "texas-mats"
      ],
      "inquiry": false
    },
    {
      "category": "tables-chairs",
      "title": "Round poker mat",
      "zh": "圆形扑克桌垫",
      "detail": "Portable mat · non-slip backing",
      "image": "catalog-41.jpg",
      "url": "https://www.coolstarpoker.com/products/24-47-round-texas-holdem-poker-mat-non-slip-portable-top",
      "tags": [
        "texas-mats"
      ],
      "inquiry": false
    },
    {
      "category": "tables-chairs",
      "title": "Roulette wheel",
      "zh": "轮盘转盘",
      "detail": "Black rim · gold finish",
      "image": "table-accessory-roulette-wheel-v2.png",
      "url": "contact.html#quote-form",
      "tags": [
        "table-accessories"
      ],
      "inquiry": true
    },
    {
      "category": "tables-chairs",
      "title": "Armless poker chair",
      "zh": "无扶手扑克椅",
      "detail": "Black seat · footrest",
      "image": "catalog-45.jpg",
      "url": "https://www.coolstarpoker.com/products/adjustable-vintage-red-leather-casino-poker-chai",
      "tags": [
        "chairs"
      ],
      "inquiry": false
    },
    {
      "category": "tables-chairs",
      "title": "Adjustable poker chair",
      "zh": "可调节扑克椅",
      "detail": "Red leather · adjustable height",
      "image": "catalog-46.jpg",
      "url": "https://www.coolstarpoker.com/products/luxury-custom-poker-table-chair-red",
      "tags": [
        "chairs"
      ],
      "inquiry": false
    },
    {
      "category": "tables-chairs",
      "title": "Diamond-tufted poker chair",
      "zh": "菱格软包扑克椅",
      "detail": "Padded seat · custom options",
      "image": "catalog-47.png",
      "url": "https://www.coolstarpoker.com/products/luxury-custom-poker-table-chair-diamond-tufted-vip-seat",
      "tags": [
        "chairs"
      ],
      "inquiry": false
    },
    {
      "category": "tables-chairs",
      "title": "Adjustable armchair",
      "zh": "可调节有扶手椅子",
      "detail": "Armrests · diamond stitching",
      "image": "catalog-28.jpg",
      "url": "https://www.coolstarpoker.com/products/luxury-black-gold-vip-casino-chair-diamond-stitched-armrests",
      "tags": [
        "chairs"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Playing cards",
      "zh": "扑克牌",
      "detail": "Custom decks & card options",
      "image": "catalog-10.png",
      "url": "https://www.coolstarpoker.com/products/custom-bulk-poker-cards-100-deck-moq",
      "tags": [
        "cards"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Precision dice",
      "zh": "骰子",
      "detail": "19 mm · sharp corner",
      "image": "catalog-13.png",
      "url": "https://www.coolstarpoker.com/products/19mm-sharp-corner-precision-dice-5pc-set-in-foil-box",
      "tags": [
        "dice"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Ceramic dealer button",
      "zh": "庄家按钮",
      "detail": "Ceramic · weighted button",
      "image": "catalog-31.jpg",
      "url": "https://www.coolstarpoker.com/products/pro-50mm-ceramic-poker-dealer-button-weighted-26-8g",
      "tags": [
        "dealer"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "All-in button",
      "zh": "All-in牌",
      "detail": "Triangle acrylic button",
      "image": "catalog-84.jpg",
      "url": "https://www.coolstarpoker.com/products/casino-50-5mm-thick-small-blind-big-blind-all-in-and-dealer-poker-buttons",
      "tags": [
        "all-in"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Call button options",
      "zh": "Call牌选项",
      "detail": "Custom marker enquiry",
      "image": "catalog-call-options.svg",
      "url": "contact.html",
      "tags": [
        "call"
      ],
      "inquiry": true
    },
    {
      "category": "poker-supplies",
      "title": "Blind button set",
      "zh": "盲位牌",
      "detail": "Dealer, blind & all-in set",
      "image": "catalog-83.jpg",
      "url": "https://www.coolstarpoker.com/products/dealer-big-blind-small-blind-all-in-buttons",
      "tags": [
        "blinds"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Cut card options",
      "zh": "切牌选项",
      "detail": "Custom card enquiry",
      "image": "catalog-cut-options.svg",
      "url": "contact.html",
      "tags": [
        "cut-cards"
      ],
      "inquiry": true
    },
    {
      "category": "poker-supplies",
      "title": "Card guards",
      "zh": "压牌码",
      "detail": "Metal card protector options",
      "image": "catalog-55.jpg",
      "url": "https://www.coolstarpoker.com/products/random-metal-poker-card-guard-set-bulk-lucky-coins-10pcs",
      "tags": [
        "guards"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Poker chip case",
      "zh": "筹码箱",
      "detail": "Rolling aluminum case",
      "image": "catalog-08.jpg",
      "url": "https://www.coolstarpoker.com/products/rolling-aluminum-poker-chip-case-600-1000ct-trolley-suitcase",
      "tags": [
        "cases"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Chip rack",
      "zh": "码耙",
      "detail": "5-row acrylic organizer",
      "image": "catalog-62.jpg",
      "url": "https://www.coolstarpoker.com/products/clear-acrylic-poker-chip-tray-5-row-100-chip-capacity-no-lid-副本",
      "tags": [
        "racks"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Chip tray",
      "zh": "筹码托盘",
      "detail": "Clear acrylic · open tray",
      "image": "catalog-80.jpg",
      "url": "https://www.coolstarpoker.com/products/5-row-clear-acrylic-poker-chip-tray-100-chip-capacity-casino-style-chip-holder-for-texas-holdem-games",
      "tags": [
        "trays"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Card sleeve options",
      "zh": "牌套选项",
      "detail": "Custom storage enquiry",
      "image": "catalog-sleeve-options.svg",
      "url": "contact.html",
      "tags": [
        "sleeves"
      ],
      "inquiry": true
    },
    {
      "category": "poker-supplies",
      "title": "Cash drop box",
      "zh": "现金箱",
      "detail": "Black metal drop box",
      "image": "catalog-77.jpg",
      "url": "https://www.coolstarpoker.com/products/black-iron-drop-money-box-for-poker-table",
      "tags": [
        "cash"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Card shuffler",
      "zh": "洗牌机",
      "detail": "Electric multi-deck shuffler",
      "image": "catalog-71.jpg",
      "url": "https://www.coolstarpoker.com/products/professional-casino-automatic-card-shuffler-electric-8-deck-shuffling-machine",
      "tags": [
        "equipment"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Tournament timer",
      "zh": "锦标赛计时器",
      "detail": "Blind-level countdown",
      "image": "catalog-69.jpg",
      "url": "https://www.coolstarpoker.com/products/digital-poker-tournament-countdown-timer-blind-level-timing-equipment",
      "tags": [
        "equipment"
      ],
      "inquiry": false
    },
    {
      "category": "poker-supplies",
      "title": "Time bank cards",
      "zh": "延时牌",
      "detail": "Soft PVC markers",
      "image": "catalog-76.jpg",
      "url": "https://www.coolstarpoker.com/products/black-iron-drop-money-box-for-poker-table2",
      "tags": [
        "equipment"
      ],
      "inquiry": false
    },
    {
      "category": "poker-chips",
      "title": "Ceramic poker plaques",
      "zh": "陶瓷方片筹码",
      "detail": "High-denomination options",
      "image": "catalog-88.jpg",
      "url": "https://www.coolstarpoker.com/products/67x41mm-ept-ceramic-poker-plaque-high-denomination-casino-poker-chip-plaque-副本",
      "tags": [
        "ceramic-plaque"
      ],
      "inquiry": false
    },
    {
      "category": "poker-chips",
      "title": "Five-star clay chips",
      "zh": "五星边陶土筹码",
      "detail": "Clay · 40 mm / 14 g",
      "image": "catalog-89.jpg",
      "url": "https://www.coolstarpoker.com/products/39mm-ept-style-ceramic-poker-chips-white-ring-25pcs-per-roll-副本",
      "tags": [
        "clay"
      ],
      "inquiry": false
    },
    {
      "category": "poker-chips",
      "title": "Clay composite chips",
      "zh": "陶土复合筹码",
      "detail": "Clay · 14 g",
      "image": "catalog-95.jpg",
      "url": "https://www.coolstarpoker.com/products/clay-chips",
      "tags": [
        "clay"
      ],
      "inquiry": false
    },
    {
      "category": "poker-chips",
      "title": "Club ceramic chips",
      "zh": "俱乐部款陶瓷筹码",
      "detail": "Ceramic · faceted edge",
      "image": "catalog-02.jpg",
      "url": "https://www.coolstarpoker.com/products/ept-style-poker-chips-spade-star-design-7-denomination-副本",
      "tags": [
        "ceramic"
      ],
      "inquiry": false
    },
    {
      "category": "poker-chips",
      "title": "Spade & star ceramic chips",
      "zh": "黑桃星纹陶瓷筹码",
      "detail": "Ceramic · denomination styles",
      "image": "catalog-03.jpg",
      "url": "https://www.coolstarpoker.com/products/39mm-10g-ept-style-ceramic-poker-chips-25pcs-roll-casino-grade-副本",
      "tags": [
        "ceramic"
      ],
      "inquiry": false
    },
    {
      "category": "poker-chips",
      "title": "Classic ceramic chips",
      "zh": "经典陶瓷筹码",
      "detail": "Ceramic · 10 denominations",
      "image": "catalog-05.jpg",
      "url": "https://www.coolstarpoker.com/products/classic-ceramic-poker-chips-10-denomination-casino-tournament",
      "tags": [
        "ceramic"
      ],
      "inquiry": false
    },
    {
      "category": "poker-chips",
      "title": "Lucky Dragon ceramic chips",
      "zh": "幸运龙陶瓷筹码",
      "detail": "Ceramic · 39 mm / 10 g",
      "image": "catalog-06.jpg",
      "url": "https://www.coolstarpoker.com/products/poker-club-ceramic-poker-chips-10g-副本",
      "tags": [
        "ceramic"
      ],
      "inquiry": false
    },
    {
      "category": "poker-chips",
      "title": "8-stripe ABS chips",
      "zh": "八条纹ABS筹码",
      "detail": "ABS · custom logo options",
      "image": "catalog-38.png",
      "url": "https://www.coolstarpoker.com/products/8-stripe-abs-custom-logo-poker-chips-uv-print-casino",
      "tags": [
        "abs"
      ],
      "inquiry": false
    },
    {
      "category": "poker-chips",
      "title": "PP chip options",
      "zh": "PP筹码选项",
      "detail": "Material & custom style enquiry",
      "image": "material-pp-studio-v2.png",
      "url": "contact.html#quote-form",
      "tags": [
        "pp"
      ],
      "inquiry": true
    },
    {
      "category": "poker-chips",
      "title": "Acrylic chip options",
      "zh": "亚克力筹码选项",
      "detail": "Material & custom style enquiry",
      "image": "material-acrylic-studio-v2.png",
      "url": "contact.html#quote-form",
      "tags": [
        "acrylic"
      ],
      "inquiry": true
    },
    {
      "category": "poker-chips",
      "title": "Acrylic plaque options",
      "zh": "亚克力方片筹码选项",
      "detail": "Material & custom style enquiry",
      "image": "material-acrylic-plaque-studio-v2.png",
      "url": "contact.html#quote-form",
      "tags": [
        "acrylic-plaque"
      ],
      "inquiry": true
    }
  ]
};
